import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Navbar, Nav, // Popover, OverlayTrigger,
  NavDropdown, Form, Container, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { connect } from 'react-redux';
import { userLogout } from '../../redux/modules/auth';
import { setShowCreateModal, setShowShoppingCart } from '../../redux/modules/show';
import { getFromStorage } from '../../utils/storage';
import mobileIcon from '../../img/nibi icon B.svg';
import menu from '../../img/menu.svg';
import nibiLogoImg from '../../img/logo_nibi_2.png';
import userImg from '../../img/user.png';
import { apiUrl, businessUserType1 } from '../../utils/consts';
import './styles/navbar.scss';

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout()),
    setShowShoppingCart: show => dispatch(setShowShoppingCart(show)),
    setShowCreateModal: show => dispatch(setShowCreateModal(show))
  };
}

const select = state => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    showShoppingCart: state.show.showShoppingCart,
    chatNotification: state.chat.chatNotification,
    chatNotificationNumber: state.chat.chatNotificationNumber
  };
};

const customStyles = {
  dropdownIndicator: base => {
    let changes = {
      display: 'none'
    };
    return Object.assign(base, changes);
  }, placeholder: base => {
    let changes = {
      color: '#E0E0E0',
      fontWeight: '400',
      fontSize: '13px'
    };
    return Object.assign(base, changes);
  }, input: base => {
    let changes = {
      color: '#707070'
    };
    return Object.assign(base, changes);
  }, menu: base => {
    let changes = {
      zIndex: '2'
    };
    return Object.assign(base, changes);
  }, indicatorsContainer: base => {
    let changes = {
      display: 'none'
    };
    return Object.assign(base, changes);
  }, control: base => {
    let changes = {
      border: 'none',
      borderRadius: '100px',
      fontSize: '13px',
      paddingLeft: '8px',
      height: 30,
      minHeight: 30,
      boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.1), 0 2px 3px 0 rgba(0, 0, 0, 0.2)'
    };
    return Object.assign(base, changes);
  }
};

class ConnectedNavbar extends Component {

  constructor(props) {
    super(props);

    this.timeout = 0;
    this.state = {
      search: '',
      loadingSearch: false,
      searchResults: []
    };

    this.logout = this.logout.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  navbarOnClick(path) {
    this.props.history.push(path);
  }

  handleSearchChange(inputValue) {

    if (inputValue) {

      this.setState({ loadingSearch: true });

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {

        const resultsFetch = await fetch(`${apiUrl}/products/search/simple?search=${inputValue}`);
        const data = await resultsFetch.json();

        if (data.success) this.setState({ searchResults: data.results });
        this.setState({ loadingSearch: false });
      }, 1000);

    } else {
      if (this.timeout) clearTimeout(this.timeout);
      this.setState({ searchResults: [] });
    }
  }

  handleSelectSearch(option) {
    this.setState({ search: option });

    const { history } = this.props;

    if (option) {
      const { type, value } = option;

      if (type === 'product') history.push(`/productos/${value}`);
      else if (type === 'benefit') history.push(`/ayudas/${value}`);
    }
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    // const { search } = this.state;
    // if (search) this.props.history.push(`/buscar?q=${search}`);
  }

  async logout() {

    this.props.userLogout();

    const obj = getFromStorage('nibi_business_app');

    if (obj && obj.token) {

      const { token } = obj;
      fetch(`${apiUrl}/users/logout?token=${token}`);

      if (this.props.location.pathname.includes('dashboard') || this.props.location.pathname.includes('chat')) {
        this.props.history.push('/');
      }
    }
  }

  render() {
    const {
      location,
      user,
      token,
      isFoundation,
      isEnterprise,
      setShowShoppingCart,
      showShoppingCart,
      chatNotificationNumber,
      chatNotification
      // isBusinessAdmin,
    } = this.props;
    const { search, loadingSearch, searchResults } = this.state;

    // const popover = (
    //   <Popover id="popover-positioned-bottom">
    //     <Popover.Title as="h3">{user.totalNibis > 0 ?
    //       <div>Tienes {user.totalNibis} <img src={require('../../img/nibi_coins.png')} style={{ height: "15px" }} aria-hidden="true" alt="Moneda Nibi" /> nibis disponibles</div>
    //       : <div>{user.totalNibis}</div>}
    //     </Popover.Title>
    //     <Popover.Content className="nibisWindowContent">
    //       {
    //         user.nibiArray && user.nibiArray.length > 0 && user.nibiArray.slice(0).reverse().map((nibis, i) =>
    //           <div key={i} style={{ fontSize: "0.8em" }}>
    //             {nibis.nibis > 0 ? <span style={{ color: "green" }}><strong>{nibis.nibis}</strong> </span> : <span style={{ color: "red" }}><strong>{nibis.nibis}</strong> </span>}
    //             <img src={require('../../img/nibi_coins.png')} style={{ height: "15px" }} aria-hidden="true" alt="Moneda Nibi" />
    //             {nibis.description}
    //             <hr />
    //           </div>
    //         )
    //       }
    //     </Popover.Content>
    //   </Popover>
    // );

    // Cemex
    const path = location.pathname;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const dashboardRoute = 'dashboard';

    return (
      <div>
        <Navbar expand="lg">
          <Navbar.Brand>
            <Link to="/home">
              <img id="homeLogo" src={isMobile ? mobileIcon : nibiLogoImg} alt="Regresar a la página principal" />
            </Link>
          </Navbar.Brand>

          <div className='navbarCenterSection'>

            {
              token &&
              <Form inline onSubmit={this.handleSubmit}>
                <div className="search-bar">
                  <Select
                    className='search-bar-input'
                    styles={customStyles}
                    placeholder={<><i className="fas fa-search" /><span>{isMobile ? 'Estoy buscando...' : 'Buscar'}</span></>}
                    onChange={option => this.handleSelectSearch(option)}
                    onInputChange={inputValue => { this.handleSearchChange(inputValue) }}
                    options={!loadingSearch ? searchResults : []}
                    value={search}
                    isMulti={false}
                    isClearable={true}
                    escapeClearsValue={false}
                    noOptionsMessage={
                      obj => !obj.inputValue ? 'Buscar' :
                        loadingSearch ? 'Cargando...' : 'No se encontraron resultados'
                    }
                  />
                </div>
              </Form>
            }

            <Nav className="mr-auto">
              {
                (!isMobile && token) &&
                <>
                  <Link className="highlight-link" to={"/"}>
                    Inicio
                  </Link>
                  <Link className="highlight-link" onClick={() => this.props.setShowCreateModal({ show: true })}>
                    Crear
                  </Link>
                  {
                    user.nibiBusinessUserType === businessUserType1 &&
                    <Link className="highlight-link" to={"/seccion_solidaria"}>
                      Muro de la solidaridad
                    </Link>
                  }
                  <Link className="highlight-link" to={"/tienda"}>
                    Tienda
                  </Link>
                </>
              }
            </Nav>

          </div>

          {
            // Mobile right side
            isMobile &&
            <div className='userFunctionsSection'>
              {
                token && !isFoundation && !isEnterprise &&
                <div className='functionIcon' id='shoppingCartIcon' onClick={() => setShowShoppingCart(!showShoppingCart)}>
                  <i className="fas fa-shopping-cart fa-lg nav-link" alt="shopping cart" />
                </div>
              }
              <NavDropdown alignRight title={<img src={menu} alt="Expandir o contraer menú" />} className="toggle-mobile">
                {
                  (!token && !path.includes('cemex')) &&
                  <>
                    <div className='dropdownTitle'>Bienvenido</div>
                    <div className='dropdownSubtitle'>Ingresa a tu cuenta o crea una nueva</div>
                    <NavDropdown.Divider />
                  </>
                }

                {
                  token && <>
                    <Container fluid>
                      <Row noGutters>
                        <Col xs={3}>
                          <div className='functionIcon avatar' style={{ backgroundImage: user.logo && user.logo !== "" ? `url(${user.logo})` : `url(${require('../../img/user.png')})` }} />
                        </Col>
                        <Col xs={9}>
                          <div className='dropdownTitle' style={{ marginTop: '8px' }}>Bienvenido</div>
                          <div className='dropdownSubtitle'>{(isFoundation || isEnterprise) ? user.name : `${user.firstName} ${user.lastName}`}</div>
                        </Col>
                      </Row>
                    </Container>
                    <NavDropdown.Divider />

                    {
                      !isEnterprise && !isFoundation &&
                      <>
                        <NavDropdown.Item className="nav-dropdown-item"><Link to={`/${dashboardRoute}/programas`}>Mis programas</Link></NavDropdown.Item>
                        <NavDropdown.Item className="nav-dropdown-item"><Link to={`/${dashboardRoute}/compras`}>Mis compras</Link></NavDropdown.Item>
                        <NavDropdown.Item className="nav-dropdown-item"><Link to={`/${dashboardRoute}/suscripciones`}>Mis suscripciones</Link></NavDropdown.Item>
                        <NavDropdown.Item className="nav-dropdown-item"><Link to={`/${dashboardRoute}/certificados`}>Certificados</Link></NavDropdown.Item>
                      </>
                    }
                    <hr />
                  </>
                }
                <NavDropdown.Item className="nav-dropdown-item"><Link to="/explora">Programas</Link></NavDropdown.Item>
                <NavDropdown.Item className="nav-dropdown-item"><Link to="/beneficios">Tienda</Link></NavDropdown.Item>
                <NavDropdown.Item className="nav-dropdown-item"><Link to="/sobre_nibi">Sobre Nibi</Link></NavDropdown.Item>
                {
                  !token &&
                  <>
                    <NavDropdown.Item className="nav-dropdown-item"><Link to="/info/empresas">Soy Empresa</Link></NavDropdown.Item>
                    <NavDropdown.Item className="nav-dropdown-item"><Link to="/info/organizaciones">Soy ONG</Link></NavDropdown.Item>
                    <NavDropdown.Item className="nav-dropdown-item"><Link to="/info/comercios">Soy Marca</Link></NavDropdown.Item>
                  </>
                }
                {
                  token &&
                  <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="nav-dropdown-item">
                      <div onClick={this.logout}>
                        Cerrar sesión
                      </div>
                    </NavDropdown.Item>
                  </>
                }
              </NavDropdown>
            </div>
          }

          {
            // Desktop right side
            !isMobile &&
            <div className="userFunctionsSection">
              {
                token &&
                <div className="functionIcon" onClick={() => setShowShoppingCart(!showShoppingCart)}>
                  <i className="fas fa-shopping-cart fa-lg nav-link" alt="shopping cart" />
                </div>
              }
              {
                token &&
                <div className="functionIcon" onClick={() => this.props.history.push('/chat')}>
                  <i className="far fa-comment fa-lg nav-link">
                    {
                      chatNotification &&
                      <span className="chat-notification-container">
                        <span className="chat-notification-bubble"></span>
                        <span className="chat-notification-num"> {chatNotificationNumber}</span>
                      </span>
                    }
                  </i>
                </div>
              }
              {
              /* 
              {
                token &&
                <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose={true}>
                  <div className='functionIcon'>
                    <img src={require('../../img/nibi_coins.png')} style={{ height: "25px" }} alt="Total de nibis disponibles" /><span style={{ color: '#302464', fontSize: '13px' }}>{user.totalNibis}</span>
                  </div>
                </OverlayTrigger>
              }
              */
              }
              {
                token &&
                <NavDropdown title="" className='functionIcon avatar' alignRight style={{ backgroundImage: user.logo ? `url(${user.logo})` : `url(${userImg})` }}>
                  <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/perfil`)}>
                    Mi cuenta
                  </NavDropdown.Item>
                  {
                    !user.nibiBusinessRelatedUserId &&
                    <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/familia`)}>
                      Familia
                    </NavDropdown.Item>
                  }
                  <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/productos`)}>
                    Mis productos
                  </NavDropdown.Item>
                  {
                    user.nibiBusinessUserType === businessUserType1 &&
                    <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/seccion_solidaria`)}>
                      Mi muro de la solidaridad
                    </NavDropdown.Item>
                  }
                  <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/billetera`)}>
                    Billetera
                  </NavDropdown.Item>
                  <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/documentos`)}>
                    Documentos
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  {
                    user.nibiBusinessRole === 'ADMIN' &&
                    <>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/dashboard`)}>
                        Dashboard
                      </NavDropdown.Item>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/usuarios`)}>
                        Usuarios
                      </NavDropdown.Item>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/seccion_solidaria`)}>
                        Muro de la solidaridad
                      </NavDropdown.Item>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/productos`)}>
                        Productos
                      </NavDropdown.Item>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/desembolsos`)}>
                        Desembolsos
                      </NavDropdown.Item>
                      <NavDropdown.Item className="nav-dropdown-item" onClick={() => this.navbarOnClick(`/${dashboardRoute}/admin/descuentos_nomina`)}>
                        Descuentos de nómina
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>
                  }
                  <NavDropdown.Item className="nav-dropdown-item">
                    <div onClick={this.logout}>
                      Cerrar sesión
                    </div>
                  </NavDropdown.Item>
                </NavDropdown>
              } 
            </div>
          }
        </Navbar>
      </div>
    );
  }
}

const NavbarMain = connect(select, mapDispatchToProps)(ConnectedNavbar);

export default withRouter(NavbarMain);
